import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 12h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 18V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Heading3";
const Heading3 = memo(themed(Icon));
export {
  Heading3
};
//# sourceMappingURL=heading-3.js.map
